import { render, staticRenderFns } from "./commit.vue?vue&type=template&id=56795951&scoped=true"
import script from "./commit.vue?vue&type=script&lang=js"
export * from "./commit.vue?vue&type=script&lang=js"
import style0 from "./commit.vue?vue&type=style&index=0&id=56795951&prod&scoped=true&lang=css"
import style1 from "./commit.vue?vue&type=style&index=1&id=56795951&prod&lang=css"
import style2 from "./commit.vue?vue&type=style&index=2&id=56795951&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56795951",
  null
  
)

export default component.exports